module.exports = __webpack_public_path__ + "static/media/analytics_dark.a1211b28.svg";